/**
 * @fileoverview gRPC-Web generated client stub for acompanha.users.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/users/v1/users.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.users = {};
proto.acompanha.users.v1 = require('./users_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.users.v1.UsersServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.users.v1.UsersServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.users.v1.ListUsersRequest,
 *   !proto.acompanha.users.v1.ListUsersResponse>}
 */
const methodDescriptor_UsersService_ListUsers = new grpc.web.MethodDescriptor(
  '/acompanha.users.v1.UsersService/ListUsers',
  grpc.web.MethodType.UNARY,
  proto.acompanha.users.v1.ListUsersRequest,
  proto.acompanha.users.v1.ListUsersResponse,
  /**
   * @param {!proto.acompanha.users.v1.ListUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.users.v1.ListUsersResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.users.v1.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.users.v1.ListUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.users.v1.ListUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.users.v1.UsersServiceClient.prototype.listUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_UsersService_ListUsers,
      callback);
};


/**
 * @param {!proto.acompanha.users.v1.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.users.v1.ListUsersResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.users.v1.UsersServicePromiseClient.prototype.listUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_UsersService_ListUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.users.v1.GetUserRequest,
 *   !proto.acompanha.users.v1.GetUserResponse>}
 */
const methodDescriptor_UsersService_GetUser = new grpc.web.MethodDescriptor(
  '/acompanha.users.v1.UsersService/GetUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.users.v1.GetUserRequest,
  proto.acompanha.users.v1.GetUserResponse,
  /**
   * @param {!proto.acompanha.users.v1.GetUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.users.v1.GetUserResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.users.v1.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.users.v1.GetUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.users.v1.GetUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.users.v1.UsersServiceClient.prototype.getUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_GetUser,
      callback);
};


/**
 * @param {!proto.acompanha.users.v1.GetUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.users.v1.GetUserResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.users.v1.UsersServicePromiseClient.prototype.getUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/GetUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_GetUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.users.v1.CreateUserRequest,
 *   !proto.acompanha.users.v1.CreateUserResponse>}
 */
const methodDescriptor_UsersService_CreateUser = new grpc.web.MethodDescriptor(
  '/acompanha.users.v1.UsersService/CreateUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.users.v1.CreateUserRequest,
  proto.acompanha.users.v1.CreateUserResponse,
  /**
   * @param {!proto.acompanha.users.v1.CreateUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.users.v1.CreateUserResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.users.v1.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.users.v1.CreateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.users.v1.CreateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.users.v1.UsersServiceClient.prototype.createUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_CreateUser,
      callback);
};


/**
 * @param {!proto.acompanha.users.v1.CreateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.users.v1.CreateUserResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.users.v1.UsersServicePromiseClient.prototype.createUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/CreateUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_CreateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.users.v1.UpdateUserRequest,
 *   !proto.acompanha.users.v1.UpdateUserResponse>}
 */
const methodDescriptor_UsersService_UpdateUser = new grpc.web.MethodDescriptor(
  '/acompanha.users.v1.UsersService/UpdateUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.users.v1.UpdateUserRequest,
  proto.acompanha.users.v1.UpdateUserResponse,
  /**
   * @param {!proto.acompanha.users.v1.UpdateUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.users.v1.UpdateUserResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.users.v1.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.users.v1.UpdateUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.users.v1.UpdateUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.users.v1.UsersServiceClient.prototype.updateUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_UpdateUser,
      callback);
};


/**
 * @param {!proto.acompanha.users.v1.UpdateUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.users.v1.UpdateUserResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.users.v1.UsersServicePromiseClient.prototype.updateUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/UpdateUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_UpdateUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.users.v1.DeleteUserRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_UsersService_DeleteUser = new grpc.web.MethodDescriptor(
  '/acompanha.users.v1.UsersService/DeleteUser',
  grpc.web.MethodType.UNARY,
  proto.acompanha.users.v1.DeleteUserRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.users.v1.DeleteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.users.v1.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.users.v1.UsersServiceClient.prototype.deleteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_DeleteUser,
      callback);
};


/**
 * @param {!proto.acompanha.users.v1.DeleteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.users.v1.UsersServicePromiseClient.prototype.deleteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.users.v1.UsersService/DeleteUser',
      request,
      metadata || {},
      methodDescriptor_UsersService_DeleteUser);
};


module.exports = proto.acompanha.users.v1;

